// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.listingcostandfee.FeeRequirementType

export enum FeeRequirementType {
  CONDITIONAL = 'CONDITIONAL',
  INCLUDED = 'INCLUDED',
  MANDATORY = 'MANDATORY',
  OPTIONAL = 'OPTIONAL',
  SITUATIONAL = 'SITUATIONAL',
}

export const FeeRequirementType_values = [
  FeeRequirementType.CONDITIONAL,
  FeeRequirementType.INCLUDED,
  FeeRequirementType.MANDATORY,
  FeeRequirementType.OPTIONAL,
  FeeRequirementType.SITUATIONAL,
] as const;
